import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { enforceRetentionAlert, newUETransferAppAlert } from "./App";
import useAuth from "./hook/useAuth";
import useDeepVinApi, { dvSrv } from "./hook/useDeepvinApi";
import { SignOut } from "./Signin";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const SSOSignIn = () => {
  useEffect(() => {
    window.location.href = dvSrv+'/api/sso';
  }, []);
  
  return (
    <>
      <div>Redirecting to Microsoft login...</div>
      {/* <ReactJson src={{email, passcode}} /> */}
    </>
  )
}

export const SSOVerify = () => {
  const [errBar, setErrBar] = useState("")
  const { setAuth } = useAuth()
  const api = useDeepVinApi(false)
  const navigate = useNavigate()

  const query = useQuery();
  const code = query.get('code');
  const state = query.get('state');
  
  useEffect(() => {
    const verifySSO = async () => {

      // sign out first, ensure no stale auth data
      SignOut(api, setAuth)

      api.post("/api/sso/verify", {
          SSOCode: code,
          State: state
        })
      .then(({data}) => {
        setAuth(data)
        navigate("/dashboard/")
        enforceRetentionAlert(data)
        newUETransferAppAlert(data)
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          setErrBar("SSO verification failed. Please make sure the email is a valid user in DeepVin.com.")
        } else { setErrBar("Error: " + error) }
      })
    }
    if (code && state){
      verifySSO()
    }
  }, [])

  return (
    <>
    <p>{errBar && errBar}</p>
    {/* <ReactJson src={{errData}} /> */}
    </>
  )
}
  